import { Serializable } from '@/models/core/serializable';

export class ImportTeacherResult implements Serializable<ImportTeacherResult> {
  registrationCount: number;

  deserialize(input: any): ImportTeacherResult {
    this.registrationCount = input.registrationCount;
    return this;
  }
}
